const EntityHome = () => import(/* webpackChunkName: "entityHome" */ '@/components/EntityHome')
const routes = [
    {
        path: '/events',
        component: EntityHome,
        meta: { breadCrumb: 'Events', entity: 'editEvents' },
        children: [
            {
                name: 'events',
                path: '/',
                component: () => import('@/pages/event/List.vue'),
            },
            {
                name: 'editEvent',
                path: 'edit/:id',
                props: true,
                component: () => import('@/pages/event/Editor.vue'),
            },
            {
                name: 'newEvent',
                path: 'new',
                props: true,
                component: () => import('@/pages/event/Editor.vue'),
            },
        ],
    },
]

export default routes
